// there will be all the data from redux store 'selectedAccount' (not created yet)
// import store from 'redux/store';

export function login(
	username: string,
	password: string,
	language?: string,
	loginChannel?: boolean,
	enableEncryption?: boolean
) {
	return {
		user: username,
		secret: password,
		...(language && { language }),
		...(enableEncryption && { enableEncryption }),
		...(loginChannel && { loginChannel: 'SELF_CARE' }),
	};
}

export function validateLogin(username: string, otp: string) {
	return { user: username, otp, corpUser: true };
}

export function ltpaidentity(token: string) {
	return { LTPAToken: token };
}

export function passwordEncryption(user: string) {
	return { user };
}
